(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["maison-global"] && !Shopify.designMode) return;
  try {
    function maisonDiscoveryLinks(root) {
  root.querySelectorAll('a[href]').forEach((link) => {
    const url = new URL(link.href, window.location.origin);
    if (url.origin === window.location.origin && /\/collections\/all\/?$/.test(url.pathname)) {
      link.href = url.pathname.replace(/\/collections\/all\/?$/, '/pages/discover-all');
    }
  });
}
maisonDiscoveryLinks(document);
document.addEventListener('shopify:section:load', (event) => maisonDiscoveryLinks(event.target));
  } catch(e) { console.error(e); }
})();

})();
